// extracted by mini-css-extract-plugin
export default {"body":"UpdateMetadataPage_body__HsRgH"};